import React from 'react';

import { SVGComponentProps } from './svg.types';

const AddCircleFilledSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...otherSvgProps}
      >
        <path
          d="M9.99935 1.66699C5.40768 1.66699 1.66602 5.40866 1.66602 10.0003C1.66602 14.592 5.40768 18.3337 9.99935 18.3337C14.591 18.3337 18.3327 14.592 18.3327 10.0003C18.3327 5.40866 14.591 1.66699 9.99935 1.66699ZM13.3327 10.6253H10.6243V13.3337C10.6243 13.6753 10.341 13.9587 9.99935 13.9587C9.65768 13.9587 9.37435 13.6753 9.37435 13.3337V10.6253H6.66602C6.32435 10.6253 6.04102 10.342 6.04102 10.0003C6.04102 9.65866 6.32435 9.37533 6.66602 9.37533H9.37435V6.66699C9.37435 6.32533 9.65768 6.04199 9.99935 6.04199C10.341 6.04199 10.6243 6.32533 10.6243 6.66699V9.37533H13.3327C13.6743 9.37533 13.9577 9.65866 13.9577 10.0003C13.9577 10.342 13.6743 10.6253 13.3327 10.6253Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default AddCircleFilledSVG;
